var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    { style: { width: _vm.width } },
    [_vm._v(_vm._s(_vm.text)), !_vm.text ? _vm._t("default") : _vm._e()],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }